import { render } from "./Posts.vue?vue&type=template&id=2869c225&scoped=true"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2869c225"

export default script